import {
  Component,
  EventEmitter,
  Injector,
  Input,
  OnInit,
  Output
} from "@angular/core";
import { MatOptionSelectionChange } from "@angular/material/core";
import { UntypedFormControl, Validators } from "@angular/forms";
import { Observable } from "rxjs";
import { debounceTime, startWith, switchMap, tap } from "rxjs/operators";
import { GenericComponent } from "../../components/generic.component";
import { CityAutoCompleteFiltersDTO } from "../../models/city-auto-complete-filters-dto";
import { CityService } from "src/app/core/services/city.service";
import { CityDTO } from "../../models/city-dto";
import { LoadingDrivebService } from "@shared/components/loading-driveb/loading-driveb.service";
@Component({
    selector: "app-smartfleet-city-auto-complete",
    templateUrl: "./city-auto-complete.component.html",
    styleUrls: ["./city-auto-complete.component.scss"],
    standalone: false
})
export class CityAutoCompleteComponent
  extends GenericComponent
  implements OnInit
{
  loading = false;
  _disabled = false;
  name = new UntypedFormControl();
  searchForm = this.fb.group({
    name: this.name
  });

  cities: CityDTO[] = [];

  @Input() title = "";
  @Input() page = "";
  @Input() requiredText = "";
  @Input() stateId: number;
  @Output() onChange: any = new EventEmitter<CityDTO>();
  @Input() required = false;
  @Input() set disabled(value: boolean) {
    this._disabled = value;
    if (value) {
      this.searchForm.disable();
    } else {
      this.searchForm.enable();
    }
  }

  constructor(
    private cityService: CityService,
    injector: Injector,
    private loadingDrivebService: LoadingDrivebService
  ) {
    super(injector);
  }

  ngOnInit() {
    if (this.page != "") {
      let key;
      switch (this.page) {
        case "service-request":
          key = "srq-cityIdFilter";
          break;
        case "client-list":
          key = "cl-cityFilter";
          break;
        case "car-workshop":
          key = "cw-city";
          break;
        default:
          break;
      }
      //e coleta o filtro correspondente, se houver
      if (
        localStorage.getItem(key) != null &&
        localStorage.getItem(key) != ""
      ) {
        const city = JSON.parse(localStorage.getItem(key));
        this.searchForm.controls.name.setValue(city["name"]);
      }
    } else {
      this.clean();
    }

    this.name.valueChanges
      .pipe(
        debounceTime(200),
        tap(
          () => (
            (this.loading = true), this.loadingDrivebService.setAutoMode(false)
          )
        ),
        switchMap((value: string) => {
          if (value) {
            const filters = {} as CityAutoCompleteFiltersDTO;
            filters.name = value;
            filters.stateId = this.stateId;
            return this.cityService.findByFilters(filters);
          } else {
            this.loading = false;
            this.loadingDrivebService.setAutoMode(true);
            this.onChange.emit({} as CityDTO);
            return new Observable<CityDTO[]>();
          }
        })
      )
      .subscribe((data) => {
        this.cities = data;
        this.loading = false;
        this.loadingDrivebService.setAutoMode(true);
      });
  }

  handleCityChange(event: MatOptionSelectionChange, city: CityDTO) {
    if (event.isUserInput === true) {
      this.onChange.emit(city);
    }
  }

  clean(): void {
    this.searchForm.reset();
    this.cities = [];
  }

  setValue(value: string): void {
    this.searchForm.get("name").setValue(value);
    this.cities = [];
  }
}
